import { render, staticRenderFns } from "./PessoaJuridicaBase.vue?vue&type=template&id=6da0dc68"
import script from "./PessoaJuridicaBase.vue?vue&type=script&lang=js"
export * from "./PessoaJuridicaBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports